export const COMPANY_NAME = 'Back Market'
export const APP_NAME = 'pastrami'
